<h2 mat-dialog-title>
  <mat-icon>list</mat-icon>
  Hændelseslog
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  @if (typeAheadModel && organizations && !noOrganisationSelector) {
    <div class="actions" [formGroup]="filterModel">
      <mat-form-field class="actions__organizations text-right">
        <mat-label>Vælg organisation</mat-label>
        <div [formGroup]="typeAheadModel">
          <input type="text" #organizationSelect formControlName="typeAheadQuery" [matAutocomplete]="auto" matInput placeholder="Vælg" />
        </div>
        <mat-autocomplete
          #auto="matAutocomplete"
          hideSingleSelectionIndicator="true"
          [displayWith]="displayFn"
          okCustomDropDownArrowDirective>
          @for (organization of filteredOrganizations; track organization) {
            <mat-option [value]="organization">
              {{ organization.name }}
            </mat-option>
          }
        </mat-autocomplete>
        @if (selectedOrganizationId.value) {
          <mat-icon matSuffix class="clear-input-field-button" (click)="resetOrganization()">close</mat-icon>
        }
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>
  }

  <div class="form-row form-row--multi-select nolimits">
    <div class="multi-select">
      @if (actionLogReady) {
        <adm-action-log
          [organizations]="organizations"
          [organizationFilterEmitter]="organizationFilterEmitter"
          [entityId]="entityId"
          [entityType]="entityType"
          #actionLog />
      }
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="row-reverse">
  <button mat-button (click)="cancel()">Luk</button>
</mat-dialog-actions>
